<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div>
          {{loggedInUser.username}}
        </div>
        <FontAwesomeIcon 
          :icon="['fas', 'caret-down']" 
          size="lg"
          class="text-dark"
        />
      </CHeaderNavLink>
    </template>
    <CDropdownItem
      v-on:click="logout"
    >
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { mapActions, mapState, } from 'vuex'

export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      itemsCount: 42,
      VUE_APP_VUE_CONFIG_PUBLIC_PATH: window.VUE_APP_VUE_CONFIG_PUBLIC_PATH,
    }
  },
  computed: {
    ...mapState({
      'loggedInUser': state => state.loggedInUser,
    }),
  },
  methods: {
    ...mapActions({
      logout: 'logout',
    }),
  },
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>